var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatarHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 49,
    viewBox: "0 0 48 49",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m44 24.5c0 11.0457-8.9543 20-20 20s-20-8.9543-20-20 8.9543-20 20-20 20 8.9543 20 20z",
    fill: "#1575e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.8038 35.4998c4.2361-1.8526 7.1962-6.0805 7.1962-10.9998 0-6.6274-5.3726-12-12-12s-12 5.3726-12 12c0 4.9196 2.9604 9.1477 7.197 11.0002-2.6383 1.1538-4.7816 3.2289-6.0232 5.8187 3.1206 2.0129 6.8373 3.1811 10.827 3.1811 3.9896 0 7.7063-1.1682 10.8269-3.1811-1.2417-2.59-3.3853-4.6653-6.0239-5.8191z",
    fill: "#a6cfff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1575e5"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m21 27.5c.5523 0 1 .4477 1 1 0 1.1046.8954 2 2 2s2-.8954 2-2c0-.5523.4477-1 1-1s1 .4477 1 1c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4c0-.5523.4477-1 1-1z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 22c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 22c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatarHappy);
export default __webpack_public_path__ + "static/media/user-avatar-happy.52b0a03754d4b7e6ca421eea1f4b674c.svg";
export { ForwardRef as ReactComponent };